import React, { useState, useEffect, useRef, createRef } from "react";
import {useNavigate} from "react-router-dom";
import L from 'leaflet';
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";

export default function Contact() {

  const recaptchaRef = useRef();
  //const recaptchaRef = createRef();
  const navigate = useNavigate();
  const formRef = useRef();
  const [recaptchaKey, setRecaptchaKey] = useState(0);
   
  useEffect (()=>{
          setRecaptchaKey(current=>current+1); // Incrémentez la clé pour forcer un rechargement du reCAPTCHA
          console.log('useEffect recaptcha ');

        }, []);

  useEffect(() => {
    const container = L.DomUtil.get('geolocalisation_left');
    if(container != null){
      container._leaflet_id = null;
    }

    var map = L.map('geolocalisation_left').setView([48.870683, 2.311715], 16);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(map);
    L.marker([48.870683, 2.311715]).addTo(map)
      .bindPopup('Laurent Montagner Magnétiseur')
      .openPopup();
  }, []);

  const onSubmit = async (event) => {
  console.log('enter onSubmit');
  event.preventDefault();
   // Récupérez les valeurs des champs du formulaire
  const fname = document.getElementById('fname').value;
  const lname = document.getElementById('lname').value;
  const mail = document.getElementById('mail').value;
  const phone = document.getElementById('phone').value;
  const message = document.getElementById('message').value;
  const recaptchaValue = recaptchaRef.current.getValue();
  console.log('onSubmit recaptchaValue', recaptchaValue);

  try {
    const res = await axios.post('http://localhost:5000/verifier-recaptcha', {
      response: recaptchaValue,
      formData: { fname, lname, mail, phone, message }
    });
    if (res.data.success) {
      console.log('success captchat');
      formRef.current.reset();
      //navigate('/');
      //window.location.href = "/accueil#landing";
      window.scrollTo(0, 0);
      //setRecaptchaKey(prevKey => prevKey + 1); // Incrémentez la clé pour forcer un rechargement du reCAPTCHA
      recaptchaRef.current.reset();//permet rechargement recaptcha
    } else {
      alert("Échec de la vérification du reCAPTCHA, veuillez réessayer.");
      setRecaptchaKey(prevKey => prevKey + 1); // Incrémentez la clé pour forcer un rechargement du reCAPTCHA
      //recaptchaRef.current.reset();//permet rechargement recaptcha NE FONCTIONNE PAS

    }
  } catch (err) {
    console.error(err);
  }
};

  return (
    <section id="contact" style={{padding: '6em 0'}}>
      <div className="container">
        <div className="panel panel-default">
          <div className="panel-heading text-center">
            <h1>Adresse de rendez-vous</h1>
          </div>
          <div className="panel-body">
            <div className="row text-center" style={{fontSize: '20px', marginBottom: '30px'}}>
              <div className="col-lg-6">
                <img style={{verticalAlign: 'middle'}} alt="icon mal" src="resources/img/icon-mail.png" width="70px" height="70px" />
                <span>montagnerlaurent@gmail.com</span>
              </div>
              <div className="col-lg-6">
                <img style={{verticalAlign: 'middle'}} src="resources/img/icon-tel.png" width="70px" height="70px" alt="icon tel"/>
                <span>06 64 27 63 13</span>
              </div>
            </div>
            <div className="row text-center" style={{fontSize: '20px'}}>
              <div className="col-md-offset-2 col-md-8">
                <div className="col-lg-12">
                  <img style={{verticalAlign: 'middle'}} src="resources/img/icon-home.png" width="70px" height="70px" alt="icon home"/>
                  <span>Sur Paris</span>
                </div>
                <div className="col-lg-12">
                  <span> Laurent MONTAGNER</span> <br />
                  <span> 18, rue jean MERMOZ</span> <br />
                  <span>75008 PARIS</span> <br />
                  <span>RDC fond de cour droite</span> <br />
                  <span> Metro: FRANKLIN D. ROOSEVELT</span>
                </div>
                <div className="col-lg-12" id="geolocalisation_left" style={{transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)'}}></div>
              </div>
            </div>
            <div id="panelform" className="row">
              <div className="col-lg-12">
                <form id="contactForm" onSubmit={onSubmit} ref={formRef}>
                    <h3 className="text-center" style={{paddingBottom: '1.3em', textDecoration: 'underline'}}>Envoyez moi votre message</h3>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                      <ReCAPTCHA ref={recaptchaRef} sitekey="6LfPUEYpAAAAAPrudSR6KPw-FE5rmLUZEW4C3N8Y" key={recaptchaKey} />
                    </div>                    
                    <div id="formulaire" style={{background: 'none !important', border:'none !important'}}>
                      <fieldset id="fieldset">
                        <div className="row form-group">
                          <span className="col-lg-2 text-center">
                            <i className="fa fa-user bigicon"></i>
                          </span>
                          <div className="col-lg-10">
                            <input id="fname" name="fname" className="form-control" />
                          </div>
                        </div>
                        <div className="row form-group">
                          <span className="col-lg-2 text-center">
                            <i className="fa fa-user bigicon"></i>
                          </span>
                          <div className="col-lg-10">
                            <input id="lname" name="lname" className="form-control" />
                          </div>
                        </div>
                        <div className="row form-group">
                          <span className="col-lg-2 text-center"><i className="fa fa-envelope-o bigicon"></i></span>
                          <div className="col-lg-10">
                            <input id="mail" type="email" name="mail" className="form-control" />
                          </div>
                        </div>
                        <div className="row form-group">
                          <span className="col-lg-2 text-center">
                            <i className="fa fa-phone-square bigicon"></i>
                          </span>
                          <div className="col-lg-10">
                            <input id="phone" type="text" name="phone" className="form-control" />
                          </div>
                        </div>
                        <div className="row">
                          <div className="form-group">
                            <span className="col-lg-2 text-center"><i className="fa fa-pencil-square-o bigicon"></i></span>
                            <div className="col-lg-10 form-group">
                              <input id="message" className="form-control" name="message" required />
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="col-lg-offset-2 col-lg-2">
                            <button type="submit" value="submit" className="btn btn-primary btn-lg">ENVOYER</button>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}